import { gql } from "@apollo/client";

export const PressReleases = gql`
  query PressReleases($size: Int!, $offset: Int!, $language: String!) {
    pressReleases(
      where: { language: $language, offsetPagination: {size: $size, offset: $offset}, sortByDate: true }
    ) {
      pageInfo {
        offsetPagination {
          hasMore
          total
        }
      }
      nodes {
        title
        uri
        pressReleaseFields {
          publishDate
        }
      }
    }
  }
`;